import extractMixin from "@/mixins/extractMixin.js";
import moment from 'moment';
import AmazeDynamicComponent from "@/components/Widgets/AmazeDynamicComponent";
import AmazeTermsViewer from "@/components/Widgets/AmazeTermsViewer";
import AmazeEmailAddressInput from "@/components/Widgets/AmazeEmailAddressInput";
import AmazeAddress from "@/components/Widgets/AmazeAddress";
import AmazeSelectThenOther from "@/components/Widgets/AmazeSelectThenOther";

export default {
  mixins: [extractMixin],
  components: {
    AmazeEmailAddressInput,
    AmazeDynamicComponent,
    AmazeTermsViewer,
    AmazeAddress,
    AmazeSelectThenOther
  },
  methods: {
    getFormattedDate: function (date) {
      return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
    }
  },
  computed: {
    terms() {
      return this.extract('event.content.terms', false);
    },
    acknowledgement() {
      return this.extract('event.content.acknowledgement', false);
    },
    id() {
      return this.extract('event.id');
    },
    cssClasses() {
      return 'registration-id-' + this.extract('event.id', 0) + ' ' + 'registration-slug-' + this.extract('event.slug', '');
    },
    showWaiver() {
      // By default, we should be showing the waiver. However, if the waiver meta entry is set
      // to false, that indicates we should not show the waiver.
      return this.extract('event.content.meta.waiver', true) && !this.terms;
    },
    hasAside() {
      var aside = this.extract('event.content.aside.custom');
      return aside !== null && typeof aside !== 'undefined';
    },
    defaultAside() {
      return !this.extract('event.content.aside.custom') || !this.extract('event.content.aside.html');
    },
    contactAddress() {
      return process.env.VUE_APP_CONTACT_ADDRESS;
    },
    membershipOptions () {
      return this.extract('event.content.membershipOptions', false);
    }
  }
};
